/* Estampa em reticula (frente 1): a lupa segue o mouse ou o dedo e mostra a
   estampa do produto ampliada sobre o algodao.
   A lupa tem duas camadas: a tinta do arquivo de impressao (sobre preto, ou
   sobre branco na camiseta branca) e, por baixo, o ladrilho do algodao
   repetido. A tinta entra com lighten (ou darken): no furo do meio-tom aparece
   o tecido. As duas estao na mesma escala (72 px por cm), entao o ladrilho
   encaixa pixel a pixel com o relevo que ja vem gravado na tinta.
   As imagens grandes so baixam quando a secao chega perto da tela; ate elas
   chegarem, a lupa mostra a base ampliada. Parada, a lupa fica no ponto onde a
   reticula e mais densa, para mostrar sem precisar mexer. */
(function () {
  "use strict";
  var palcos = document.querySelectorAll("[data-reticula]");
  if (!palcos.length) return;

  Array.prototype.forEach.call(palcos, function (palco) {
    var lupa = palco.querySelector(".reticula-lupa");
    var base = palco.querySelector("img");
    var url = palco.getAttribute("data-lupa");
    var urlTecido = palco.getAttribute("data-tecido");
    var clara = palco.hasAttribute("data-clara");
    var pos = { x: Number(palco.getAttribute("data-inicio-x")) || 0.5, y: Number(palco.getAttribute("data-inicio-y")) || 0.5 };
    // tamanho da imagem da lupa, ja conhecido pela lista: a base ampliada de
    // espera fica na mesma escala e nao da salto quando a imagem chega
    var grande = { w: Number(palco.getAttribute("data-lupa-l")) || 2196, h: Number(palco.getAttribute("data-lupa-a")) || 2928 };
    var trama = null, carregada = false;

    function carregar() {
      if (carregada) return;
      carregada = true;
      if (base && (base.currentSrc || base.src)) lupa.style.backgroundImage = "url(\"" + (base.currentSrc || base.src) + "\")";
      desenhar();
      var tinta = new Image(), tecido = new Image(), faltam = urlTecido ? 2 : 1, falhou = false;
      function chegou() {
        if (--faltam > 0) return;
        if (falhou || !tinta.naturalWidth) return;      // fica a base ampliada
        grande = { w: tinta.naturalWidth, h: tinta.naturalHeight };
        if (tecido.naturalWidth) {
          trama = { w: tecido.naturalWidth, h: tecido.naturalHeight };
          lupa.style.backgroundImage = "url(\"" + url + "\"), url(\"" + urlTecido + "\")";
          lupa.style.backgroundRepeat = "no-repeat, repeat";
          lupa.style.backgroundBlendMode = (clara ? "darken" : "lighten") + ", normal";
        } else {
          lupa.style.backgroundImage = "url(\"" + url + "\")";
        }
        desenhar();
      }
      tinta.onload = chegou;
      tinta.onerror = function () { falhou = true; chegou(); };
      tinta.src = url;
      if (urlTecido) {
        tecido.onload = tecido.onerror = chegou;
        tecido.src = urlTecido;
      }
    }

    function desenhar() {
      var W = palco.clientWidth, H = palco.clientHeight;
      if (!W || !H) return;
      var L = lupa.offsetWidth;
      // centro da lupa no ponto, sem sair do palco
      var cx = Math.max(L / 2, Math.min(W - L / 2, pos.x * W));
      var cy = Math.max(L / 2, Math.min(H - L / 2, pos.y * H));
      lupa.style.transform = "translate(" + Math.round(cx - L / 2) + "px," + Math.round(cy - L / 2) + "px)";
      // a imagem grande em tamanho natural: o ponto (x, y) fica no centro da lupa;
      // o ladrilho do algodao parte da mesma origem, para casar com a tinta
      var bx = Math.round(-(cx / W) * grande.w + L / 2), by = Math.round(-(cy / H) * grande.h + L / 2);
      var tam = grande.w + "px " + grande.h + "px", onde = bx + "px " + by + "px";
      if (trama) {
        lupa.style.backgroundSize = tam + ", " + trama.w + "px " + trama.h + "px";
        lupa.style.backgroundPosition = onde + ", " + onde;
      } else {
        lupa.style.backgroundSize = tam;
        lupa.style.backgroundPosition = onde;
      }
    }

    function mover(e) {
      var r = palco.getBoundingClientRect();
      pos.x = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
      pos.y = Math.max(0, Math.min(1, (e.clientY - r.top) / r.height));
      carregar();
      desenhar();
    }
    palco.addEventListener("pointermove", mover);
    palco.addEventListener("pointerdown", mover);
    palco.addEventListener("keydown", function (e) {
      var passo = { ArrowLeft: [-0.03, 0], ArrowRight: [0.03, 0], ArrowUp: [0, -0.03], ArrowDown: [0, 0.03] }[e.key];
      if (!passo) return;
      e.preventDefault();
      pos.x = Math.max(0, Math.min(1, pos.x + passo[0]));
      pos.y = Math.max(0, Math.min(1, pos.y + passo[1]));
      carregar();
      desenhar();
    });
    // posiciona a lupa so quando a secao chega perto da tela (carregar) e, no
    // resize, uma vez por quadro: ler o tamanho do palco ao abrir a pagina
    // obrigava o navegador a calcular o layout antes da hora (leveza, 27/09/2026)
    base.addEventListener("load", function () { if (carregada) desenhar(); });
    var pedido = 0;
    window.addEventListener("resize", function () {
      if (!carregada || pedido) return;
      pedido = requestAnimationFrame(function () { pedido = 0; desenhar(); });
    });

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (es, o) {
        if (es[0].isIntersecting) { carregar(); o.disconnect(); }
      }, { rootMargin: "400px" }).observe(palco);
    } else carregar();
  });
})();
